import React from 'react'
import {AiOutlineStar} from 'react-icons/ai'
import {HiUserGroup} from 'react-icons/hi'
import {BsTrophy} from 'react-icons/bs'
import {RiEmotionHappyLine} from 'react-icons/ri'
import {Link} from 'react-router-dom'

const DlaczegoOniko = () => {

    const dlaczegoItems = [
        {
            id: 1,
            icon: <AiOutlineStar size={55}/>,
            text: "NAJLEPSZA OFERTA",
            text2: "Gwarancja najlepszej oferty rynkowej dopasowanej do potrzeb Klienta – wybieramy najlepsze rozwiązanie dostosowane do oceny Twojej zdolności."
        }, {
            id: 2,
            icon: <HiUserGroup size={55}/>,
            text: "KOMPLEKSOWA OBSŁUGA",
            text2: "Doradztwo i wsparcie na każdym etapie procesu leasingowego , kredytowego: współpracujemy z najlepszymi profesjonalistami w swojej dziedzinie."
        }, {
            id: 3,
            icon: <BsTrophy size={55}/>,
            text: "PROFESJONALIZM",
            text2: "Ponad 30 letnie doświadczenie oraz szeroka wiedza mi.in bankowa właścicieli pozwala skutecznie osiągnąć wyznaczony cel zgodnie z najwyższymi standardami obsługi Klienta."
        }, {
            id: 4,
            icon: <RiEmotionHappyLine size={55}/>,
            text: "ZADOWOLENIE KLIENTA",
            text2: "Bazujemy na poleceniach, więc jesteśmy przekonani, że Twoje zadowolenie z obsługi przełoży się na kolejną rekomendację wśród Twoich znajomych i przyjaciół."
        }, 
    ]

  return (
    <div className='w-full' id="dlaczegomy">
      <div className='justify-center flex mx-auto max-w-[1450px] bg-white py-20'>
          <div className='text-center pt-10'>
            <h2 className='text-xl sm:text-4xl font-semibold sm:pb-10 px-10'>DLACZEGO WARTO WYBRAĆ ONIKO?</h2>
            <div className='grid sm:grid-cols-2 text-sm sm:text-base'>
                {dlaczegoItems.map((item) => (
                    <div className='px-20 pt-14'>
                        <div className='mx-auto justify-center flex text-[#4C4C9B]'>{item.icon}</div>
                        <p className='font-semibold text-lg py-2'>{item.text}</p>
                        <p>{item.text2}</p>
                    </div>    
                ))} 
            </div>
            <Link to="/onas">
                <button className='mt-20 bg-[#4C4C9B] py-2 px-3 rounded-xl text-white hover:scale-95 duration-500'>
                    Poznaj firmę oraz ekspertów
                </button>
            </Link>  
          </div>
      </div>
    </div>
  )
}

export default DlaczegoOniko